<template>
    <div>
        <div v-if="showModal" class="modal">
            <div class="modal-content">
                <span class="close" @click="closeModal">×</span>
                <div id="playercontainer" class="player-container"></div>
            </div>
        </div>
    </div>
</template>


<script>
import { Config, PixelStreaming } from "@epicgames-ps/lib-pixelstreamingfrontend-ue5.3";
import { Application, PixelStreamingApplicationStyle } from "@epicgames-ps/lib-pixelstreamingfrontend-ui-ue5.3";

export default {
    name: "PlayerView",

    props: {
        targetFloor: String,
    },

    data() {
        return {
            showModal: false,
            stream: null,
            application: null,
        };
    },
    methods: {
        openModal() {
            this.showModal = true;
            setTimeout(() => {
                this.initPixelStreaming();
            }, 1000); // 延迟以确保 DOM 已渲染
        },
        closeModal() {
            this.showModal = false;

            if (this.stream) {
                try {
                    this.stream.disconnect();
                } catch (err) {
                    console.error("断开 PixelStreaming 流失败:", err);
                }
            }

            this.stream = null;
            this.application = null;

            const container = document.getElementById("playercontainer");
            if (container) container.innerHTML = "";
        },
        // 初始化 Pixel Streaming
        initPixelStreaming() {
            console.log('---- 调用初始化方式 ------')
            if (this.stream) return;
            // 应用样式
            const style = new PixelStreamingApplicationStyle();
            style.applyStyleSheet();
            // 配置 Pixel Streaming
            const config = new Config({
                useUrlParams: false,
                initialSettings: {
                    ss: "wss://zhmx.qdgkcy.com:21007",
                    AutoConnect: true,
                    AutoPlayVideo: true,
                    MatchViewportRes: true,
                    HoveringMouse: true,
                },
            });
            // 创建 Pixel Streaming 实例
            this.stream = new PixelStreaming(config);
            // 创建应用程序实例
            this.application = new Application({
                stream: this.stream,
                onColorModeChanged: (isLight) => style.setColorMode(isLight),
            });

            //隐藏默认UI元素
            const container = document.getElementsByClassName("player-container")[0];
            // 将 Pixel Streaming 根元素添加到容器中
            if (container && this.application) {
                container.style.width = "100%";
                container.style.height = "100%";
                container.appendChild(this.application.rootElement);
            }
            // 自定义UI样式
            const playerUI = document.querySelector('#playerUI');
            if (playerUI instanceof HTMLElement) {
                playerUI.style.position = 'absolute';
                playerUI.style.top = '0'
                playerUI.style.left = '0'
                playerUI.style.zIndex = '1';
            }

            const connection = document.querySelector('#connection');
            if (connection instanceof HTMLElement) {
                connection.style.display = 'none';
                connection.style.left = '90%'
            }
            const controls = document.querySelector('#controls');
            if (controls instanceof HTMLElement) {
                controls.style.display = 'none';
                controls.style.left = '85%'
                controls.style.top = '20%'
            }

            // 视频初始化完成后切换楼层
            this.stream.addEventListener("videoInitialized", () => {
                console.log(this.targetFloor)
                console.log("Pixel Streaming 视频就绪，自动切换楼层:", this.targetFloor);
                this.switchFloor(this.targetFloor);
            });

            // 响应事件监听（可选）
            this.stream.addResponseEventListener("handle_responses", (res) => {
                console.log("PixelStreaming response:", res);
            });
        },

        // 封装切换楼层方法 (复用之前业务逻辑 所以需要构造一个同样的Json请求)
        switchFloor(Floor) {

            if (!this.stream) return;

            let json1 = JSON.stringify(
                {
                    "Type": "SceneMgr",
                    "Function": "LoadScene",
                    "Data": {
                        "SceneName": "C_zuo_fenceng",
                        "SceneId": "1991332002124664834",
                        "CameraConfig": {
                            "location": {
                                "x": -10860.800999617572,
                                "y": -35675.41377217958,
                                "z": -28872.441789380144
                            },
                            "rotation": {
                                "pitch": 17.655000472366794,
                                "yaw": -30.98749643713232,
                                "roll": 1.6688817164529438e-15
                            },
                            "springArmLength": 300
                        },
                        "Weather": "Sunny",
                        "SceneTime": "Day",
                        "NavigationConfig": {
                            "allowWASD": true,
                            "allowEQ": true,
                            "allowZoom": true,
                            "allowRotate": true,
                            "cameraSpeed": 10000,
                            "cameraRotateSpeed": 1,
                            "cameraZoomSpeed": 1
                        },
                        "ModelHideList": ["eb859076-f206-477f-b036-a925c156b05b", "d81452fa-3e73-4143-9c9b-8bca50a7631b", "4dfb8e72-b3d9-4284-b93e-e92e921c7514", "41090b7a-be81-4551-9e04-9e7e27671a2a", "5f4bfc97-0fd2-4e26-ab6f-b9050e1dca58", "e7d98022-5f6a-432c-a5f6-44875eda880a", "93c9b5ec-2ce6-45dd-b161-cb6816979ac5", "0d2cde19-1b55-4b0d-ac8a-b22af4f232b2", "d7956ae9-66b3-4acf-b058-e7425c6a5c7b", "9ce98e7f-15dc-40a1-8ef7-79b709b14a4f", "c6c9d253-9585-4fd2-90bc-1c155a3cf731", "a56b61ac-9ced-4bca-91f9-b88e66bca0b4", "b359fd5e-e534-465f-8a3f-d13cd782db37", "656d8a15-cb3f-40ce-9b22-8961ddb35898"],
                        "ContentList": []
                    }
                });
            let json2 = JSON.stringify({
                "Type": "CameraManager",
                "Function": "SwitchFloor",
                "Data": {
                    "Floor": Floor,
                    "External ": true
                }
            });

            this.stream.emitUIInteraction(JSON.parse(json1));
            this.stream.emitUIInteraction(JSON.parse(json2));
        },
    },
};
</script>

<style scoped>
.modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-content {
    width: 80vw;
    height: 80vh;
    background: #000;
    position: relative;
}

.close {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 30px;
    cursor: pointer;
    color: white;
    z-index: 10;
}
</style>
